module.exports = __webpack_public_path__ + "img/蓝@3x.39220461.png";